import indexed_db from './indexed-db'
import app_context from './app-context'

const api = {
  indexed_db,
  app_context,
}

export default api
